import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { faqs } from "../../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-4 py-16 sm:py-20" aria-label="Frequently asked questions" data-id="element-113" data-mp="122vbicn8knnw">
      <div className="mx-auto max-w-3xl" data-id="element-114" data-mp="1puakgo9iq384">
        <SectionHeading title="Frequently asked questions" data-id="element-115" data-mp="1urtxjkuhc9yh" />
        <div className="divide-y divide-navy/10 rounded-2xl bg-cream ring-1 ring-navy/10" data-id="element-116" data-mp="1utdihor2z96l">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-117" data-mp="1kzoampj34iq5" data-mpi={i}>
                <h3 data-id="element-118" data-mp="28r1xwh2dpo49">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left text-base font-bold text-ink focus:outline-none focus-visible:bg-gold-pale sm:text-lg" data-id="element-119" data-mp="28qtm6shzsoun">
                    {f.q}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-120" data-mp="2yga8wu0c0tgl" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-121" data-mp="32hvrmvzjs1yp">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-122" data-mp="32jzxhjh0bb1m">
                      <p className="px-5 pb-5 text-base leading-relaxed text-ink/75" data-id="element-123" data-mp="1i3d1fvegjebd">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
        <CtaButton label="Get the Decision Lab™ now" className="mt-10" data-id="element-124" data-mp="2btccynvujaiz" />
      </div>
    </section>;
}